import React, { useState } from 'react';

import { IconButton } from '@material-ui/core';
import PropTypes from 'prop-types';

import { TagDeleteIcon } from 'components/CustomIcons';
import { ConfirmationDialog } from 'components/Dialogs/ConfirmationDialog/ConfirmationDialog';

import { ButtonComponent } from '../ButtonComponent/ButtonComponent';

export function IconWithConfirmation({
  message,
  handleConfirm,
  value,
  Component,
  buttonClassName,
  type,
  confirmText,
  disabled,
  showWarningIcon,
  title,
  defaultMessage,
}) {
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const handleToggleDialog = event => {
    event.stopPropagation();
    setOpenConfirmation(prevValue => !prevValue);
  };
  const handleYes = event => {
    handleToggleDialog(event);
    handleConfirm(value);
  };

  const getMessage = () => (defaultMessage ? `Are you sure you want to delete this ${message}?` : message);

  const renderButton = () => {
    if (type === 'icon') {
      return (
        <IconButton onClick={handleToggleDialog} aria-label="delete" className={buttonClassName} disabled={disabled}>
          <Component />
        </IconButton>
      );
    }
    if (type === 'button') {
      return (
        <ButtonComponent
          text="Delete"
          onClick={handleToggleDialog}
          Icon={TagDeleteIcon}
          className="flex-start"
          fullWidth
          disabled={disabled}
        />
      );
    }
    return null;
  };

  return (
    <>
      {renderButton()}
      <ConfirmationDialog
        open={openConfirmation}
        message={getMessage()}
        handleYes={handleYes}
        handleNo={handleToggleDialog}
        confirmText={confirmText}
        showWarningIcon={showWarningIcon}
        title={title}
      />
    </>
  );
}

IconWithConfirmation.propTypes = {
  handleConfirm: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string]),
  message: PropTypes.node.isRequired,
  Component: PropTypes.elementType,
  buttonClassName: PropTypes.string,
  type: PropTypes.string,
  confirmText: PropTypes.string,
  disabled: PropTypes.bool,
  showWarningIcon: PropTypes.bool,
  title: PropTypes.string,
  defaultMessage: PropTypes.bool,
};

IconWithConfirmation.defaultProps = {
  Component: TagDeleteIcon,
  defaultMessage: true,
  buttonClassName: '',
  type: 'icon',
  confirmText: 'Delete',
  disabled: false,
  value: '',
  showWarningIcon: true,
};
